import moment from 'moment';
import {BASE_PATH, OAUTH_PATH, ACCESS_TOKEN_EXPIRES_BUFFER_SEC} from '@constants/index';
import type {AccessTokenData} from '@vsTypes/oauth';
import httpClient from './httpClient';

export const refreshAccessToken = async (expiredAccessToken?: string | null): Promise<AccessTokenData | null> => {
    try {
        const refreshUrl = `${BASE_PATH}${OAUTH_PATH}/refresh`;
        const headers = expiredAccessToken ? {Authorization: `Bearer ${expiredAccessToken}`} : undefined;
        const response = await httpClient.post(refreshUrl, {}, headers ? {headers} : undefined);
        const {data} = response;
        const expiresAt = moment().add(data.expires_in, 'seconds').valueOf();
        const tokenData = {
            accessToken: data.access_token,
            tokenType: data.token_type,
            expiresAt
        };

        return tokenData;
    } catch (error: any) {
        if (error.response?.status === 401) {
            return null;
        }
        throw error;
    }
};

export const getIsTokenExpired = (expiresAt: number): boolean => {
    const bufferTime = moment().add(ACCESS_TOKEN_EXPIRES_BUFFER_SEC, 'seconds').valueOf();
    const isExpired = bufferTime >= expiresAt;

    return isExpired;
};

export const calculateExpiresAt = (expiresInSeconds: number): number => {
    const expiresAt = moment().add(expiresInSeconds, 'seconds').valueOf();

    return expiresAt;
};
